export class UsersApi {
    constructor(http) {
        this.http = http;
    }
    getMe() {
        return this.http.get('/me');
    }
    getUser(userId) {
        return this.http.get(`/users/${userId}`);
    }
}
//# sourceMappingURL=UsersApi.js.map